export const Athletics = [
    'Speed Kills',
    'Strength Dominates',
    'Athletes Rule'
]